// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2D3Hv","rightAdornment":"Header_rightAdornment__1EDTV"};